angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/login/join-engineer.html',
    '\n' +
    '<body id="body">\n' +
    '\n' +
    '<!-- Header -->\n' +
    '<header class="navbar minified navbar-fixed-top">\n' +
    '	<div class="container-fluid">\n' +
    '		<div class="user-dashboard" data-toggle="collapse" data-target="#user-utility">\n' +
    '			<ul class="list-inline">\n' +
    '				<li class="user-name hidden-xs">Michael</li>\n' +
    '				<!-- Keep second background-image avater.png as is! Replace first [avatar-01.jpg] with submitted photo by user! -->\n' +
    '				<li class="user-photo" style="background-image:url(assets/img/avatar-01.jpg),url(assets/img/avatar.png);"></li>\n' +
    '			</ul>\n' +
    '		</div>\n' +
    '		<div class="navbar-header dashboard">\n' +
    '			<a class="navbar-toggle dashboard" data-toggle="collapse" data-target=".navbar-collapse"></a>\n' +
    '			<a href="" ui-sref="index"  class="logo">\n' +
    '				<svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '					<polygon class="pol-a" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53"/>\n' +
    '					<polygon class="pol-b" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7"/>\n' +
    '					<polygon class="pol-c" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3"/>\n' +
    '				</svg>\n' +
    '				<div>\n' +
    '					<strong>pe</strong><span>4</span>h\n' +
    '				</div>\n' +
    '			</a>\n' +
    '		</div>\n' +
    '		<nav id="my-nav" class="navbar-collapse dashboard collapse">\n' +
    '			<ul class="nav navbar-nav">\n' +
    '				<li><a href="requests-default.htm">Requests</a></li>\n' +
    '				<li><a href="proposals-default.htm">Proposals</a></li>\n' +
    '			</ul>\n' +
    '		</nav>\n' +
    '		<div id="user-utility" class="collapse pull-right">\n' +
    '			<ul class="user-utility">\n' +
    '				<li class="credits"><a href="buy-credits.htm">Buy Credits<i class="fa fa-usd fa-fw"></i></a></li>\n' +
    '				<!--li><a href="profile.htm">Profile<i class="fa fa-user fa-fw"></i></a></li-->\n' +
    '				<li><a href="index.htm" onclick="document.getElementById(\'loading\').className=\'show\';">Sign Out<i class="fa fa-sign-out fa-fw alt"></i></a></li>\n' +
    '			</ul>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</header>\n' +
    '\n' +
    '<!-- Profile -->\n' +
    '<section class="content dashboard">\n' +
    '	<div class="container">\n' +
    '		<div class="row">\n' +
    '			<div class="col-xs-12 col-sm-8">\n' +
    '				<h2>Engineer Profile</h2>\n' +
    '				<!-- Tabs -->\n' +
    '				<ul class="nav nav-tabs nav-justified tabs-style-a">\n' +
    '					<li class="active"><a data-toggle="tab" href="#tab-profile-info"><i class="fa fa-info"></i>Profile Info</a></li>\n' +
    '					<li><a data-toggle="tab" href="#tab-bio"><i class="fa fa-cubes"></i>Bio</a></li>\n' +
    '				</ul>\n' +
    '				<div class="tab-content">\n' +
    '					<!-- Tab-1: Profile Info -->\n' +
    '					<div class="tab-pane fade in active" id="tab-profile-info">\n' +
    '						<form method="post">\n' +
    '							<div class="dashboard-box">\n' +
    '								<ul class="list-inline">\n' +
    '									<li>\n' +
    '										<!-- Keep second background-image avater.png as is! Replace first [avatar-01.jpg] with user\'s photo -->\n' +
    '										<div class="user-photo" style="background-image:url(assets/img/avatar-001.jpg),url(assets/img/avatar.png);"></div>\n' +
    '									</li>\n' +
    '									<li>\n' +
    '										<span class="btn-file alt"><i class="fa fa-plus"></i> Add a Photo<input type="file"></span>\n' +
    '									</li>\n' +
    '								</ul>\n' +
    '							</div>\n' +
    '							<div class="dashboard-box">\n' +
    '								<h4 class="mb30">Contact Information</h4>\n' +
    '								<div class="row">\n' +
    '									<div class="col-sm-6 form-group">\n' +
    '										<input type="text" class="form-control input-lg" id="FirstName" placeholder="First Name" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'First Name\'" required value="Michael">\n' +
    '									</div>\n' +
    '									<div class="col-sm-6 form-group">\n' +
    '										<input type="text" class="form-control input-lg" id="LastName" placeholder="Last Name" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Last Name\'" required value="MacArthur">\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<div class="row">\n' +
    '									<div class="col-sm-6 form-group">\n' +
    '										<input class="form-control input-lg" name="company" type="text" placeholder="Business Name" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Business Name\'" required>\n' +
    '									</div>\n' +
    '									<div class="col-sm-6 form-group">\n' +
    '										<input class="form-control input-lg" name="phone" data-mask="(999) 999-9999" type="tel" placeholder="Phone" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Phone\'">\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<div class="row">\n' +
    '									<div class="col-sm-6">\n' +
    '										<div class="form-group">\n' +
    '										<input type="text" class="form-control input-lg" id="city" placeholder="City" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'City\'">\n' +
    '										</div>\n' +
    '									</div>\n' +
    '									<div class="col-sm-3">\n' +
    '										<div class="form-group">\n' +
    '											<label class="select">\n' +
    '												<select class="form-control input-lg" name="user[state]">\n' +
    '												<option value="">State</option>\n' +
    '												<option value="">AK</option>\n' +
    '												<option value="">AL</option>\n' +
    '												<option value="">AR</option>\n' +
    '												<option value="">AZ</option>\n' +
    '												<option value="">CA</option>\n' +
    '												<option value="">CO</option>\n' +
    '												<option value="">CT</option>\n' +
    '												<option value="">DC</option>\n' +
    '												<option value="">DE</option>\n' +
    '												<option value="">Continue...</option>\n' +
    '												</select>\n' +
    '											</label>\n' +
    '										</div>\n' +
    '									</div>\n' +
    '									<div class="col-sm-3">\n' +
    '										<div class="form-group">\n' +
    '										<input type="text" class="form-control input-lg" id="zip2" placeholder="Zip Code" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Zip Code\'">\n' +
    '										</div>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<h5>Email</h5>\n' +
    '								<div class="form-group">\n' +
    '									<input class="form-control input-lg" name="Email" type="text" placeholder="Email Address" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Email Address\'" value="michael.macarthur.jnr@luxengineersco.com">\n' +
    '								</div>\n' +
    '								<h5 class="mt25">Password</h5>\n' +
    '								<div class="row">\n' +
    '									<div class="col-sm-6 form-group">\n' +
    '										<input type="password" class="form-control input-lg" id="Password" placeholder="Choose Password" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Choose Password\'" value="12121212" onchange="document.getElementById(\'pass-repeat\').className=\'\';">\n' +
    '									</div>\n' +
    '									<div class="col-sm-6 form-group">\n' +
    '										<div id="pass-repeat" class="hidden">\n' +
    '										<input type="password" class="form-control input-lg" id="Re-Password" placeholder="Repeat Password" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Repeat Password\'" required>\n' +
    '										</div>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '							</div>\n' +
    '							<div class="dashboard-box">\n' +
    '								<h4 class="mb30">Travel Preferences</h4>\n' +
    '								<h5 class="mt30">Distance</h5>\n' +
    '								<div class="row">\n' +
    '									<div class="col-sm-6">\n' +
    '										<div class="form-group mb20">\n' +
    '											<label class="select">\n' +
    '												<select class="form-control input-lg" name="user[state]" id="Distance">\n' +
    '													<option value="">Please Select</option>\n' +
    '													<option value="">Cannot travel</option>\n' +
    '													<option value="">Up to 25 miles</option>\n' +
    '													<option value="">Up to 50 miles</option>\n' +
    '													<option value="">Up to 100 Miles</option>\n' +
    '													<option value="">Up to 200 Miles</option>\n' +
    '													<option value="">Up to 300 Miles</option>\n' +
    '													<option value="">No travel limits</option>\n' +
    '												</select>\n' +
    '											</label>\n' +
    '										</div>\n' +
    '									</div>\n' +
    '									<div class="col-sm-6">\n' +
    '										<!-- Map -->\n' +
    '										<div class="g-map" style="background-image:url(img/zip_circle_map.png);"></div>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '							</div>\n' +
    '							<div class="dashboard-box">\n' +
    '								<h4 class="mb20">Licenses</h4>\n' +
    '								<div id="license-a" class="collapse in">\n' +
    '									<div class="row">\n' +
    '										<div class="col-xs-7 col-sm-8 col-md-4">\n' +
    '											<h5>License Type</h5>\n' +
    '											<div class="form-group">\n' +
    '												<label class="select input-type">\n' +
    '													<select class="form-control input-lg">\n' +
    '														<option value="">Please Select</option>\n' +
    '														<option value="type1">Type 1</option>\n' +
    '														<option value="type2">Type 2</option>\n' +
    '														<option value="type3">Type 3</option>\n' +
    '														<option value="type4">Type 4</option>\n' +
    '														<option value="type5">Type 5</option>\n' +
    '														<option value="type6">Type 6</option>\n' +
    '														<option value="type7">Type 7</option>\n' +
    '													</select>\n' +
    '												</label>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div class="col-xs-5 col-sm-4 col-md-3">\n' +
    '											<h5>State</h5>\n' +
    '											<div class="form-group">\n' +
    '												<label class="select">\n' +
    '													<select class="form-control input-lg" name="user[state]">\n' +
    '													<option value="">State</option>\n' +
    '													<option value="">AK</option>\n' +
    '													<option value="">AL</option>\n' +
    '													<option value="">AR</option>\n' +
    '													<option value="">AZ</option>\n' +
    '													<option value="" selected>CA</option>\n' +
    '													<option value="">CO</option>\n' +
    '													<option value="">CT</option>\n' +
    '													<option value="">DC</option>\n' +
    '													<option value="">DE</option>\n' +
    '													<option value="">Continue...</option>\n' +
    '													</select>\n' +
    '												</label>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div class="col-xs-7 col-sm-8 col-md-4">\n' +
    '											<h5>Expires</h5>\n' +
    '											<div class="form-group">\n' +
    '												<div class="input-group date" data-date="23-05-2019" data-date-format="mm-dd-yyyy">\n' +
    '													<input title="" data-original-title="" class="form-control input-lg" value="23-05-2019" type="text">\n' +
    '													<span class="input-group-addon"><i class="fa fa-calendar"></i></span>\n' +
    '												</div>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div id="add-link-a" class="col-xs-5 col-sm-4 col-md-1">\n' +
    '											<div class="add-license">\n' +
    '												<a class="btn" data-toggle="collapse" href="#license-b" onclick="document.getElementById(\'add-link-a\').className=\'hidden\';document.getElementById(\'remove-link-a\').className=\'\';">Add</a>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div id="remove-link-a" class="hidden">\n' +
    '											<div class="col-sm-1 sliding">\n' +
    '												<div class="add-license">\n' +
    '													<a class="btn fa fa-trash" data-toggle="collapse" href="#license-a" onclick="return confirm(\'Delete this record?\');"></a>\n' +
    '												</div>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<div id="license-b" class="collapse">\n' +
    '									<hr class="visible-xs visible-sm hr-alt">\n' +
    '									<div class="row">\n' +
    '										<div class="col-xs-7 col-sm-8 col-md-4">\n' +
    '											<h5 class="visible-xs visible-sm">Type</h5>\n' +
    '											<div class="form-group">\n' +
    '												<label class="select input-type">\n' +
    '													<select class="form-control input-lg">\n' +
    '														<option value="">Please Select</option>\n' +
    '														<option value="type1">Type 1</option>\n' +
    '														<option value="type2">Type 2</option>\n' +
    '														<option value="type3">Type 3</option>\n' +
    '														<option value="type4">Type 4</option>\n' +
    '														<option value="type5">Type 5</option>\n' +
    '														<option value="type6">Type 6</option>\n' +
    '														<option value="type7">Type 7</option>\n' +
    '													</select>\n' +
    '												</label>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div class="col-xs-5 col-sm-4 col-md-3">\n' +
    '											<h5 class="visible-sm visible-xs">State</h5>\n' +
    '											<div class="form-group">\n' +
    '												<label class="select">\n' +
    '													<select class="form-control input-lg" name="user[state]">\n' +
    '													<option value="">State</option>\n' +
    '													<option value="">AK</option>\n' +
    '													<option value="">AL</option>\n' +
    '													<option value="">AR</option>\n' +
    '													<option value="">AZ</option>\n' +
    '													<option value="" selected>CA</option>\n' +
    '													<option value="">CO</option>\n' +
    '													<option value="">CT</option>\n' +
    '													<option value="">DC</option>\n' +
    '													<option value="">DE</option>\n' +
    '													<option value="">Continue...</option>\n' +
    '													</select>\n' +
    '												</label>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div class="col-xs-7 col-sm-8 col-md-4">\n' +
    '											<h5 class="visible-sm visible-xs">Expires</h5>\n' +
    '											<div class="form-group">\n' +
    '												<div class="input-group date" data-date="23-05-2019" data-date-format="mm-dd-yyyy">\n' +
    '													<input title="" data-original-title="" class="form-control input-lg" value="23-05-2019" type="text">\n' +
    '													<span class="input-group-addon"><i class="fa fa-calendar"></i></span>\n' +
    '												</div>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div id="add-link-b" class="col-xs-5 col-sm-4 col-md-1">\n' +
    '											<div class="add-license-new">\n' +
    '												<a class="btn" data-toggle="collapse" href="#license-c" onclick="document.getElementById(\'add-link-b\').className=\'hidden\';document.getElementById(\'remove-link-b\').className=\'\';">Add</a>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div id="remove-link-b" class="hidden">\n' +
    '											<div class="col-sm-1 sliding">\n' +
    '												<div class="add-license-new">\n' +
    '													<a class="btn fa fa-trash" data-toggle="collapse" href="#license-b" onclick="return confirm(\'Delete this record?\');"></a>\n' +
    '												</div>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<div id="license-c" class="collapse">\n' +
    '									<hr class="visible-xs visible-sm hr-alt">\n' +
    '									<div class="row">\n' +
    '										<div class="col-xs-7 col-sm-8 col-md-4">\n' +
    '											<h5 class="visible-sm visible-xs">Type</h5>\n' +
    '											<div class="form-group">\n' +
    '												<label class="select input-type">\n' +
    '													<select class="form-control input-lg">\n' +
    '														<option value="">Please Select</option>\n' +
    '														<option value="type1">Type 1</option>\n' +
    '														<option value="type2">Type 2</option>\n' +
    '														<option value="type3">Type 3</option>\n' +
    '														<option value="type4">Type 4</option>\n' +
    '														<option value="type5">Type 5</option>\n' +
    '														<option value="type6">Type 6</option>\n' +
    '														<option value="type7">Type 7</option>\n' +
    '													</select>\n' +
    '												</label>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div class="col-xs-5 col-sm-4 col-md-3">\n' +
    '											<h5 class="visible-sm visible-xs">State</h5>\n' +
    '											<div class="form-group">\n' +
    '												<label class="select">\n' +
    '													<select class="form-control input-lg" name="user[state]">\n' +
    '													<option value="">State</option>\n' +
    '													<option value="">AK</option>\n' +
    '													<option value="">AL</option>\n' +
    '													<option value="">AR</option>\n' +
    '													<option value="">AZ</option>\n' +
    '													<option value="" selected>CA</option>\n' +
    '													<option value="">CO</option>\n' +
    '													<option value="">CT</option>\n' +
    '													<option value="">DC</option>\n' +
    '													<option value="">DE</option>\n' +
    '													<option value="">Continue...</option>\n' +
    '													</select>\n' +
    '												</label>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div class="col-xs-7 col-sm-8 col-md-4">\n' +
    '											<h5 class="visible-sm visible-xs">Expires</h5>\n' +
    '											<div class="form-group">\n' +
    '												<div class="input-group date" data-date="23-05-2019" data-date-format="mm-dd-yyyy">\n' +
    '													<input title="" data-original-title="" class="form-control input-lg" value="23-05-2019" type="text">\n' +
    '													<span class="input-group-addon"><i class="fa fa-calendar"></i></span>\n' +
    '												</div>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div id="add-link-c" class="col-xs-5 col-sm-4 col-md-1">\n' +
    '											<div class="add-license-new">\n' +
    '												<a class="btn" data-toggle="collapse" href="#license-d" onclick="document.getElementById(\'add-link-c\').className=\'hidden\';document.getElementById(\'remove-link-c\').className=\'\';">Add</a>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '										<div id="remove-link-c" class="hidden">\n' +
    '											<div class="col-sm-1 sliding">\n' +
    '												<div class="add-license-new">\n' +
    '													<a class="btn fa fa-trash" data-toggle="collapse" href="#license-c" onclick="return confirm(\'Delete this record?\');"></a>\n' +
    '												</div>\n' +
    '											</div>\n' +
    '										</div>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<div class="form-group mt40 mb40">\n' +
    '									<button type="submit" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#modal-thanks">Save &amp; Continue</button>\n' +
    '								</div>\n' +
    '							</div>\n' +
    '						</form>\n' +
    '					</div>\n' +
    '					<!-- Tab-2: Experience -->\n' +
    '					<div class="tab-pane fade in" id="tab-bio">\n' +
    '						<form method="post">\n' +
    '							<div class="dashboard-box">\n' +
    '								<h4 class="mb30">Professional Information</h4>\n' +
    '								<h5>Describe your Experience and the Services You Provide</h5>\n' +
    '								<textarea class="form-control mb20" rows="15" placeholder="EXAMPLE: My services are very special..." onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'EXAMPLE: My services are very special...\'"></textarea>\n' +
    '							</div>\n' +
    '							<div class="dashboard-box">\n' +
    '								<h4 class="mb30">Links</h4>\n' +
    '								<h5>Website</h5>\n' +
    '								<div class="form-group">\n' +
    '									<input type="text" class="form-control input-lg" id="Website" placeholder="" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'\'" value="http://">\n' +
    '								</div>\n' +
    '								<h5 class="mt40">Social Media Connections</h5>\n' +
    '								<div class="row mt15 mb40">\n' +
    '									<div class="col-sm-4 col-md-3">\n' +
    '										<a href="#"><i class="fa fa-facebook"></i> Facebook</a>\n' +
    '									</div>\n' +
    '									<div class="col-sm-4 col-md-3">\n' +
    '										<a href="#"><i class="fa fa-twitter"></i> Twitter</a>\n' +
    '									</div>\n' +
    '									<div class="col-sm-4 col-md-3">\n' +
    '										<a href="#"><i class="fa fa-linkedin"></i> LinkedIn</a>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<button type="submit" class="btn btn-primary btn-lg">Save</button>\n' +
    '								<div class="clearfix mb40"></div>\n' +
    '							</div>\n' +
    '						</form>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div class="col-xs-12 col-sm-4">\n' +
    '				<!-- Icon -->\n' +
    '				<div class="hexagon-lg"><i class="icon-engineer"></i></div>\n' +
    '				<h3 class="mb30">Lorem ipsum dolor</h3>\n' +
    '				<ul class="list-group bullets-e-style">\n' +
    '					<!-- Keep <a> tag ! -->\n' +
    '					<li class="list-group-item" data-target="#how1" data-toggle="collapse">\n' +
    '						<a>Duis aute irure dolor in repreh</a>\n' +
    '						<div id="how1" class="collapse">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>\n' +
    '					</li>\n' +
    '					<li class="list-group-item" data-target="#how2" data-toggle="collapse">\n' +
    '						<a>Duis autem vel eum est irure</a>\n' +
    '						<div id="how2" class="collapse">Et tamen in busdam neque pecun modut est neque nonor et per ned libiding gen epular et soluta nobis.</div>\n' +
    '					</li>\n' +
    '					<li class="list-group-item" data-target="#how3" data-toggle="collapse">\n' +
    '						<a>Ei sumo ferri invidunt per</a>\n' +
    '						<div id="how3" class="collapse">Et tamen in busdam neque pecun modut est neque nonor et imper ned libiding gen epular et soluta nobis eligent optio.</div>\n' +
    '					</li>\n' +
    '					<li class="list-group-item" data-target="#how4" data-toggle="collapse">\n' +
    '						<a>At sea tollit, pro ipsum</a>\n' +
    '						<div id="how4" class="collapse">Eum ei alii aliquip fierent, te mea choro nostrud, ad doming essent albucius pro.</div>\n' +
    '					</li>\n' +
    '				</ul>\n' +
    '				<hr class="mt40 mb40">\n' +
    '				<ul class="list-group bullets-a-style">\n' +
    '					<li class="list-group-item" data-target="#faq1" data-toggle="collapse">\n' +
    '						<a>Lorem ipsum dolor sit amet, consectetur adipiscing elit?</a>\n' +
    '						<div id="faq1" class="collapse faq">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</div>\n' +
    '					</li>\n' +
    '					<li class="list-group-item" data-target="#faq2" data-toggle="collapse">\n' +
    '						<a>Excepteur sint occaecat cupidatat non proident?</a>\n' +
    '						<div id="faq2" class="collapse faq">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>\n' +
    '					</li>\n' +
    '					<li class="list-group-item" data-target="#faq3" data-toggle="collapse">\n' +
    '						<a>Et tamen in busdam neque?</a>\n' +
    '						<div id="faq3" class="collapse faq">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</div>\n' +
    '					</li>\n' +
    '					<li class="list-group-item" data-target="#faq4" data-toggle="collapse">\n' +
    '						<a>Ut enim ad minim veniam, quis nostrud?</a>\n' +
    '						<div id="faq4" class="collapse faq">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>\n' +
    '					</li>\n' +
    '				</ul>\n' +
    '				<div class="text-right">\n' +
    '					<a href="#">Read more &nbsp; <i class="fa fa-angle-right fa-lg"></i></a>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</section>\n' +
    '\n' +
    '\n' +
    '<!-- Modal Thanks -->\n' +
    '<div id="modal-thanks" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">\n' +
    '	<div class="modal-dialog modal-sm">\n' +
    '		<div class="modal-content">\n' +
    '			<div class="modal-header">\n' +
    '				<a class="close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times"></i></a>\n' +
    '				<h4 class="modal-title">Congratulations</h4>\n' +
    '			</div>\n' +
    '			<div class="modal-body">\n' +
    '				<p>\n' +
    '					Your profile has been updated. You can return to this page at anytime to make changes.\n' +
    '					<br>\n' +
    '					<br>\n' +
    '					Click <strong>View</strong> button below to view how others will see your profile when you submit a proposal.\n' +
    '				</p>\n' +
    '			</div>\n' +
    '			<div class="modal-footer">\n' +
    '				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n' +
    '				<button type="button" class="btn btn-primary" data-dismiss="modal" onclick="location.href=\'profile-engineer.htm\';">View</button>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</div>\n' +
    '');
}]);
